// Captured at module load — BEFORE the Supabase client parses and clears the URL
// (detectSessionInUrl runs async on client init). This makes invite / recovery
// links detectable without racing the client, and surfaces an expired/invalid
// link instead of silently landing on Sign in.
//
// Must be imported for its side effect ahead of the Supabase client — main.tsx
// does `import './lib/recovery'` as its first statement.
export type RecoveryState = {
  recovery: boolean;
  errorMsg: string | null;
  accessToken: string | null;
  refreshToken: string | null;
};

function capture(): RecoveryState {
  if (typeof window === 'undefined') return { recovery: false, errorMsg: null, accessToken: null, refreshToken: null };
  const read = (s: string) => new URLSearchParams(s.replace(/^[#?]/, ''));
  const h = read(window.location.hash);
  const q = read(window.location.search);
  const type = h.get('type') || q.get('type');            // implicit: #type=recovery|invite
  const errCode = h.get('error_code') || q.get('error_code');
  const errDesc = h.get('error_description') || q.get('error_description');
  // Tokens are captured here (before the client parses & clears the fragment) so
  // the set-password screen can establish the session itself — no race with
  // detectSessionInUrl. PKCE recovery/invite land as ?code=… with no fragment;
  // the PASSWORD_RECOVERY event (auth.tsx) covers that path.
  const recovery = type === 'recovery' || type === 'invite';
  const errorMsg = errCode ? (errDesc ? decodeURIComponent(errDesc).replace(/\+/g, ' ') : errCode) : null;
  return { recovery, errorMsg, accessToken: h.get('access_token'), refreshToken: h.get('refresh_token') };
}

export const recoveryState: RecoveryState = capture();
